module.exports = __webpack_public_path__ + "static/media/icon_jh2.86b4addc.png";